import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { LockedDayPermissions } from '../../../models/permissions/permission.models';
import { AppConfig } from '../../../app/app.config';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';

@IonicPage()
@Component({
  selector: 'page-implementer-initialiser',
  templateUrl: 'implementer-initialiser.html',
})
export class ImplementerInitialiserPage {
  config = AppConfig.settings;

  dailyLogDate: PtLuxonDate;
  lockedDayPermissions: LockedDayPermissions;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private permissionService: PermissionsService,
    private supportContextService: SupportContextService,
  ) {
    this.dailyLogDate = this.navParams.get('dailyLogDate');
    this.lockedDayPermissions = this.navParams.get('lockedDayPermissions');
  }

  async ngOnInit() {

  }

  ionViewDidEnter() {
    this.supportContextService.setComponentContext(SupportContextKey.ImplementerMode, 'Implementer Mode', 'ImplementerInitialiserPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-initialiser/implementer-initialiser.ts